import BasicLayout from "@/layouts/basic-layout";

const meta = {
    auth: false,
    cache: false,
};
export default {
    path: "/cityOrder",
    name: "cityOrder",
    redirect: {
        name: "cityOrder",
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: "/cityOrder/list",
            name: "cityOrderList",
            meta: {
                ...meta,
                title: "市工单管理",
                cache: true,
            },
            component: () => import("@/pages/cityOrder/CityOrderList.vue"),
        },
        {
            path: "/cityOrder/detail/:id",
            name: "cityOrderDetail",
            meta: {
                ...meta,
                title: "市工单详情",
            },
            component: () => import("@/pages/cityOrder/CityOrderDetail.vue"),
        },
    ],
};
